import { BASE_URL } from './Constants.js';

export function customFetch(route, options) {
    const url = BASE_URL + route;
    return fetch(url, options);
}